<template>
  <v-list dense>
    <v-list dense v-if="item">
      <div class="d-block" v-for="(origin, index) in origins" :key="index">
        <div v-if="origin.type === 'Boolean'" class="d-flex justify-start align-center align-content-center">
          <v-icon style="font-size: 16px"
                  :style="!item[origin.key] ? 'color: green' : 'color: red'"
          >
            {{ !item[origin.key] ? 'mdi-check-circle-outline' : 'mdi-alert-circle-outline' }}
          </v-icon>
          <p class="ma-0 pa-0 mx-2">{{ origin.name }}</p>
        </div>
        <div  v-if="origin.type === 'Text'" class="d-flex align-center align-content-center mt-2">
          <p class="ma-0 pa-0 mr-2">{{ origin.name }}:</p>
          <p class="ma-0 pa-0">{{ item[origin.key] ? item[origin.key] : '-'}}</p>
        </div>
      </div>
    </v-list>
    <div v-else class="d-flex justify-start align-center align-content-center">
      <p class="ma-0 pa-0 mx-2">{{ $t('storage.integrations.brainag.withoutInfractions') }}</p>
    </div>
  </v-list>
</template>

<script>
  import _ from 'lodash'
  import i18n from '@/plugins/i18n'

  export default {
    name: 'ListComponent',
    props: {
      item: {
        type: Object,
        required: true
      }
    },

    computed: {
      verifyOrigin() {
        return (item) => _.find(this.items, (i) => {
          return item === i.origem
        })
      }
    },

    data:() => ({
      origins: [{
        key: "conservationUnit",
        type: 'Boolean',
        name: i18n.t("storage.fields.extraField.conservationUnit")
      },{
        key: "ibamaEmbarg",
        type: 'Boolean',
        name: i18n.t("storage.fields.extraField.ibamaEmbarg")
      },{
        key: "indígenasEarth",
        type: 'Boolean',
        name: i18n.t("storage.fields.extraField.indígenasEarth")
      },{
        key: "moratoria",
        type: 'Boolean',
        name: i18n.t("storage.fields.extraField.moratoria")
      },{
        key: "quilombolasCom",
        type: 'Boolean',
        name: i18n.t("storage.fields.extraField.quilombolasCom")
      },{
        key: "semaEmbarg",
        type: 'Boolean',
        name: i18n.t("storage.fields.extraField.semaEmbarg")
      },{
        key: "embargadasGoias",
        type: 'Boolean',
        name: i18n.t("storage.fields.extraField.embargadasGoias")
      },{
        key: "moratoriaSoja",
        type: 'Boolean',
        name: i18n.t("storage.fields.extraField.moratoriaSoja")
      },{
        key: "calculoGHG",
        type: 'Boolean',
        name: i18n.t("storage.fields.extraField.calculoGHG")
      },{
        key: "embargadasLDI",
        type: 'Boolean',
        name: i18n.t("storage.fields.extraField.embargadasLDI")
      },{
        key: "amazoniaProtege",
        type: 'Boolean',
        name: i18n.t("storage.fields.extraField.amazoniaProtege")
      },{
        key: "prodes",
        type: 'Boolean',
        name: i18n.t("storage.fields.extraField.prodes")
      },{
        key: "povosComunidadesTradicionais",
        type: 'Boolean',
        name: i18n.t("storage.fields.extraField.povosComunidadesTradicionais")
      },{
        key: "prodesCerrado",
        type: 'Boolean',
        name: i18n.t("storage.fields.extraField.prodesCerrado")
      },{
        key: "deterAmazonia",
        type: 'Boolean',
        name: i18n.t("storage.fields.extraField.deterAmazonia")
      },{
        key: "inpe",
        type: 'Boolean',
        name: i18n.t("storage.fields.extraField.inpe")
      },{
        key: "deterCerrado",
        type: 'Boolean',
        name: i18n.t("storage.fields.extraField.deterCerrado")
      },{
        key: "uniConservaUsoSustentavel",
        type: 'Boolean',
        name: i18n.t("storage.fields.extraField.uniConservaUsoSustentavel")
      },{
        key: "uniConservaUsoProteçãoIntegral",
        type: 'Boolean',
        name: i18n.t("storage.fields.extraField.uniConservaUsoProteçãoIntegral")
      },{
        key: "planiciesAlagaveisDoPantanal",
        type: 'Boolean',
        name: i18n.t("storage.fields.extraField.planiciesAlagaveisDoPantanal")
      },{
        key: "embargadasIcmbio",
        type: 'Boolean',
        name: i18n.t("storage.fields.extraField.embargadasIcmbio")
      },{
        key: "queimadas",
        type: 'Boolean',
        name: i18n.t("storage.fields.extraField.queimadas")
      },{
        key: "pos2017Desm",
        type: 'Text',
        name: i18n.t("storage.fields.extraField.pos2017Desm")
      }
      ]
    })
  }
</script>

<style scoped>

</style>